
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 7h2.219c.918 0 1.716.61 1.938 1.5L10.782 19h12.469l2.406-9h2.094l-2.594 9.531A1.969 1.969 0 0123.251 21H10.782c-.918 0-1.714-.61-1.938-1.5L6.219 9H4a1 1 0 010-2zm18 14c1.645 0 3 1.355 3 3s-1.355 3-3 3-3-1.355-3-3 1.355-3 3-3zm-9 0c1.645 0 3 1.355 3 3s-1.355 3-3 3-3-1.355-3-3 1.355-3 3-3zm3-14h2v3h3v2h-3v3h-2v-3h-3v-2h3V7zm-3 16c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1zm9 0c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1z"}})])
          )
        }
      }
    